(function () {
    if (window.BBProductCardCarousel && typeof window.BBProductCardCarousel.init === 'function') {
      window.BBProductCardCarousel.init(document);
      return;
    }

    window.BBProductCardCarousel = {
      init: function (root) {
        var scope = root || document;
        var selector = '[data-bb-product-card]:not([data-bb-carousel-ready])';
        var cards = Array.prototype.slice.call(scope.querySelectorAll(selector));
        if (scope.matches && scope.matches(selector)) cards.unshift(scope);

        cards.forEach(function (card) {
          var mediaItems = Array.prototype.slice.call(card.querySelectorAll('[data-bb-media]'));
          var prevBtn = card.querySelector('[data-bb-prev]');
          var nextBtn = card.querySelector('[data-bb-next]');
          var mediaLink = card.querySelector('[data-bb-media-link]');
          var dots = Array.prototype.slice.call(card.querySelectorAll('[data-bb-dot]'));

          card.setAttribute('data-bb-carousel-ready', 'true');

          if (!mediaItems.length) return;

          var currentIndex = 0;
          var startX = 0;
          var startY = 0;
          var movedX = 0;
          var movedY = 0;
          var isTouching = false;
          var suppressClick = false;

          function setExternalVideoState(mediaItem, shouldPlay) {
            mediaItem.querySelectorAll('iframe').forEach(function (iframe) {
              if (!iframe.contentWindow) return;

              var videoType = iframe.getAttribute('data-video-type');
              if (videoType === 'youtube') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  event: 'command',
                  func: shouldPlay ? 'playVideo' : 'pauseVideo',
                  args: []
                }), '*');
              } else if (videoType === 'vimeo') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  method: shouldPlay ? 'play' : 'pause'
                }), '*');
              }
            });
          }

          function updateVideoState(mediaItem, isPlaying) {
            mediaItem.setAttribute('data-bb-video-playing', isPlaying ? 'true' : 'false');
          }

          function hydrateImages(mediaItem) {
            mediaItem.querySelectorAll('[data-bb-deferred-image]').forEach(function (image) {
              var src = image.getAttribute('data-bb-src');
              var srcset = image.getAttribute('data-bb-srcset');

              if (srcset) image.setAttribute('srcset', srcset);
              if (src) image.setAttribute('src', src);

              image.removeAttribute('data-bb-src');
              image.removeAttribute('data-bb-srcset');
              image.removeAttribute('data-bb-deferred-image');
            });
          }

          function hydrateDeferredPlayers(mediaItem) {
            mediaItem.querySelectorAll('deferred-media').forEach(function (deferredMedia) {
              if (deferredMedia.querySelector('video, iframe')) return;

              var template = deferredMedia.querySelector('template');
              if (!template || !template.content) return;

              deferredMedia.appendChild(template.content.cloneNode(true));
              template.remove();
            });
          }

          function playMedia(mediaItem) {
            if (!mediaItem.classList.contains('bb-product-card__media-item--video') || card.closest('[hidden]')) return;

            hydrateDeferredPlayers(mediaItem);

            mediaItem.querySelectorAll('video').forEach(function (video) {
              video.muted = true;
              video.loop = true;
              video.playsInline = true;

              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            });

            setExternalVideoState(mediaItem, true);
            updateVideoState(mediaItem, true);
          }

          function pauseMedia(mediaItem) {
            mediaItem.querySelectorAll('video').forEach(function (video) {
              video.pause();
            });

            setExternalVideoState(mediaItem, false);
            updateVideoState(mediaItem, false);
          }

          function setActive(index, fromUser) {
            if (!mediaItems.length) return;

            if (index < 0) index = mediaItems.length - 1;
            if (index >= mediaItems.length) index = 0;

            currentIndex = index;

            mediaItems.forEach(function (mediaItem, mediaIndex) {
              var isActive = mediaIndex === currentIndex;
              mediaItem.classList.toggle('is-active', isActive);
              mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');

              if (isActive) {
                hydrateImages(mediaItem);
                mediaItem.removeAttribute('inert');
                playMedia(mediaItem);
              } else {
                mediaItem.setAttribute('inert', '');
                pauseMedia(mediaItem);
              }
            });

            dots.forEach(function (dot, dotIndex) {
              dot.classList.toggle('is-active', dotIndex === currentIndex);
            });

            if (fromUser) {
              card.classList.add('is-carousel-active');
            }
          }

          function resetCarousel() {
            card.classList.remove('is-carousel-active');
            setActive(0, false);
          }

          setActive(0, false);

          if ('IntersectionObserver' in window && mediaItems[1]) {
            var adjacentMediaObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                hydrateImages(mediaItems[1]);
                adjacentMediaObserver.disconnect();
              });
            }, { rootMargin: '250px' });

            adjacentMediaObserver.observe(card);
          }

          card.addEventListener('mouseenter', function () {
            if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            if (!card.classList.contains('has-hover-image') || card.classList.contains('is-carousel-active')) return;
            setActive(1, false);
          });

          if (prevBtn) {
            prevBtn.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              setActive(currentIndex - 1, true);
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              setActive(currentIndex + 1, true);
            });
          }

          card.addEventListener('bb:card-media-reset', function () {
            resetCarousel();
            mediaItems.forEach(pauseMedia);
          });

          card.addEventListener('mouseleave', function () {
            if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            if (card.classList.contains('bb-options-active')) return;
            resetCarousel();
          });

          if (mediaLink && mediaItems.length > 1) {
            mediaLink.addEventListener('touchstart', function (event) {
              if (!event.touches || !event.touches.length) return;

              hydrateImages(mediaItems[(currentIndex + 1) % mediaItems.length]);
              hydrateImages(mediaItems[(currentIndex - 1 + mediaItems.length) % mediaItems.length]);

              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              movedX = 0;
              movedY = 0;
              isTouching = true;
              suppressClick = false;
            }, { passive: true });

            mediaLink.addEventListener('touchmove', function (event) {
              if (!isTouching || !event.touches || !event.touches.length) return;

              movedX = event.touches[0].clientX - startX;
              movedY = event.touches[0].clientY - startY;

              if (Math.abs(movedX) > 16 && Math.abs(movedX) > Math.abs(movedY)) {
                event.preventDefault();
              }
            }, { passive: false });

            mediaLink.addEventListener('touchend', function () {
              if (!isTouching) return;

              isTouching = false;

              if (Math.abs(movedX) > 40 && Math.abs(movedX) > Math.abs(movedY)) {
                suppressClick = true;

                if (movedX < 0) {
                  setActive(currentIndex + 1, true);
                } else {
                  setActive(currentIndex - 1, true);
                }

                window.setTimeout(function () {
                  suppressClick = false;
                }, 260);
              }
            }, { passive: true });

            mediaLink.addEventListener('click', function (event) {
              if (!suppressClick) return;

              event.preventDefault();
              event.stopPropagation();
              suppressClick = false;
            });
          }
        });
      }
    };

    window.BBProductCardCarousel.init(document);

    document.addEventListener('shopify:section:load', function (event) {
      window.BBProductCardCarousel.init(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      window.BBProductCardCarousel.init(event.target);
    });

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && (node.matches('[data-bb-product-card]') || node.querySelector('[data-bb-product-card]'))) {
              window.BBProductCardCarousel.init(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();


  (function () {
    if (window.BBProductCardOptions && typeof window.BBProductCardOptions.init === 'function') {
      window.BBProductCardOptions.init(document);
      return;
    }

    var activeScrollLocks = 0;
    var lockedScrollY = 0;

    function lockPageScroll() {
      if (activeScrollLocks === 0) {
        lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        document.documentElement.classList.add('bb-product-card-modal-open');

        if (document.body) {
          document.body.style.top = '-' + lockedScrollY + 'px';
          document.body.classList.add('bb-product-card-modal-open');
        }
      }

      activeScrollLocks += 1;
    }

    function unlockPageScroll() {
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
      if (activeScrollLocks > 0) return;

      var previousScrollBehavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      document.documentElement.classList.remove('bb-product-card-modal-open');

      if (document.body) {
        document.body.classList.remove('bb-product-card-modal-open');
        document.body.style.top = '';
      }

      window.scrollTo(0, lockedScrollY);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    }

    window.BBProductCardOptions = {
      init: function (root) {
        var scope = root || document;
        var selector = '[data-bb-product-card]:not([data-bb-options-ready])';
        var cards = Array.prototype.slice.call(scope.querySelectorAll(selector));
        if (scope.matches && scope.matches(selector)) cards.unshift(scope);

        cards.forEach(function (card) {
          var openBtn = card.querySelector('[data-bb-open-options]');
          var modal = card.querySelector('[data-bb-options-modal]');
          var modalPanel = card.querySelector('.bb-product-card__options-panel');
          var modalMedia = card.querySelector('[data-bb-modal-media]');
          var closeBtns = Array.prototype.slice.call(card.querySelectorAll('[data-bb-options-close]'));
          var form = card.querySelector('[data-bb-options-form]');
          var variantInput = card.querySelector('[data-bb-variant-id]');
          var variantsScript = card.querySelector('[data-bb-variants]');
          var selects = Array.prototype.slice.call(card.querySelectorAll('[data-bb-option-select]'));
          var choiceButtons = Array.prototype.slice.call(card.querySelectorAll('[data-bb-option-choice]'));
          var qtyInput = card.querySelector('[data-bb-qty-input]');
          var minusBtn = card.querySelector('[data-bb-qty-minus]');
          var plusBtn = card.querySelector('[data-bb-qty-plus]');
          var submitBtn = card.querySelector('[data-bb-submit]');
          var submitText = card.querySelector('[data-bb-submit-text]');
          var submitTotal = card.querySelector('[data-bb-submit-total]');
          var qtySummary = card.querySelector('[data-bb-qty-summary]');
          var message = card.querySelector('[data-bb-option-message]');
          var modalVideos = [];
          var openFrame = 0;
          var closeTimer = 0;
          var closeAnimationMs = 340;
          var mediaFitFrame = 0;
          var hasScrollLock = false;
          var isModalOpen = false;
          var configScript = card.querySelector('[data-bb-card-config]');
          if (!configScript) return;
          var config = JSON.parse(configScript.textContent);
          var labels = config.labels;
          var currencyCode = config.currency;
          var isBlankabox = card.hasAttribute('data-bb-blankabox');
          var localeCode = config.locale;

          if (!openBtn || !modal || !form || !variantsScript || !variantInput) return;

          card.setAttribute('data-bb-options-ready', 'true');

          if (!modal.classList.contains('is-open')) {
            modal.hidden = true;
          }

          var variants = [];
          try {
            variants = JSON.parse(variantsScript.textContent || '[]');
          } catch (error) {
            variants = [];
          }

          var optionValues = selects.map(function (select, index) {
            var values = Array.prototype.slice.call(select.options).map(function (option) {
              return option.value;
            });

            return sortOptionValues(index, values);
          });

          var selectionsReady = false;

          function enforceModalVideo(video) {
            video.autoplay = true;
            video.loop = true;
            video.muted = true;
            video.defaultMuted = true;
            video.volume = 0;
            video.controls = false;
            video.setAttribute('autoplay', '');
            video.setAttribute('loop', '');
            video.setAttribute('muted', '');
            video.setAttribute('playsinline', '');
            video.removeAttribute('controls');
          }

          function playModalVideos() {
            modalVideos.forEach(function (video) {
              enforceModalVideo(video);
              video.play().catch(function () {});
            });
          }

          function pauseModalVideos() {
            modalVideos.forEach(function (video) {
              enforceModalVideo(video);
              video.pause();
            });
          }

          function hydrateModalMedia() {
            var template = modalMedia && modalMedia.querySelector("[data-bb-modal-media-template]");
            if (!template) return;
            modalMedia.appendChild(template.content.cloneNode(true));
            template.remove();
            modalVideos = Array.prototype.slice.call(modalMedia.querySelectorAll("video.bb-product-card__modal-video"));
            modalVideos.forEach(function (video) {
            enforceModalVideo(video);
            video.addEventListener('volumechange', function () { enforceModalVideo(video); });
            video.addEventListener('play', function () { enforceModalVideo(video); });
            video.addEventListener('loadedmetadata', function () {
              enforceModalVideo(video);
              if (modal.classList.contains('is-open')) {
                video.play().catch(function () {});
              }
            });
            video.addEventListener('contextmenu', function (event) { event.preventDefault(); });
            });
          }

          function getLengthNumber(value) {
            var text = String(value || '').trim().toLowerCase();
            var match = text.match(/(\d+(?:[,.]\d+)?)\s*(?:m|metre|metres|meter|meters|mètre|mètres)\b/i);

            if (!match) return null;

            var number = parseFloat(match[1].replace(',', '.'));
            return Number.isFinite(number) ? number : null;
          }

          function isLengthOption(index, values) {
            if (isBlankabox) return false;
            var select = selects[index];
            var optionName = String(select && select.dataset.optionName ? select.dataset.optionName : '').toLowerCase();

            if (optionName.indexOf('longueur') > -1 || optionName.indexOf('length') > -1 || optionName.indexOf('lange') > -1) {
              return true;
            }

            var parsedCount = values.filter(function (value) {
              return getLengthNumber(value) !== null;
            }).length;

            return parsedCount >= Math.max(2, Math.ceil(values.length / 2));
          }

          function sortOptionValues(index, values) {
            var list = values.slice();

            if (!isLengthOption(index, list)) return list;

            return list.sort(function (a, b) {
              var aLength = getLengthNumber(a);
              var bLength = getLengthNumber(b);

              if (aLength === null && bLength === null) return 0;
              if (aLength === null) return 1;
              if (bLength === null) return -1;
              return aLength - bLength;
            });
          }

          function formatMoney(cents) {
            var value = parseInt(cents, 10);
            if (!Number.isFinite(value)) value = 0;

            var amount = value / 100;

            try {
              return new Intl.NumberFormat(localeCode || 'fr-FR', {
                style: 'currency',
                currency: currencyCode || 'EUR',
                minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
                maximumFractionDigits: 2
              }).format(amount);
            } catch (error) {
              var formattedAmount = amount.toFixed(amount % 1 === 0 ? 0 : 2).replace('.', ',');
              if (currencyCode === 'EUR') return formattedAmount + ' €';
              return currencyCode ? currencyCode + ' ' + formattedAmount : formattedAmount;
            }
          }

          function getVariantLengthText(variant) {
            if (!variant || isBlankabox) return '';

            var candidates = [];

            if (variant.options && variant.options.length) {
              candidates = candidates.concat(variant.options);
            }

            if (variant.title) {
              candidates.push(variant.title);
            }

            for (var i = 0; i < candidates.length; i += 1) {
              var text = String(candidates[i] || '').trim();
              var match = text.match(/(\d+(?:[,.]\d+)?)\s*(m(?:\b|ètre|ètres|etre|etres)?)/i);

              if (match) {
                var numberText = match[1].replace(',', '.');
                var numberValue = parseFloat(numberText);
                var cleanNumber = Number.isFinite(numberValue) ? String(numberValue).replace('.', ',') : match[1];
                var unit = numberValue === 1 ? labels.meterSingular : labels.meterPlural;

                return cleanNumber + ' ' + unit;
              }
            }

            return '';
          }

          function updateQtySummaryAndTotal(variant, qty, available) {
            var lengthText = getVariantLengthText(variant);

            if (qtySummary) {
              qtySummary.textContent = available && lengthText ? qty + ' × ' + lengthText : '';
            }

            if (submitText) {
              submitText.textContent = available ? labels.addToCart : labels.unavailable;
            }

            if (submitTotal) {
              if (available && variant && typeof variant.price !== 'undefined') {
                submitTotal.textContent = '— ' + formatMoney(parseInt(variant.price, 10) * qty);
              } else {
                submitTotal.textContent = '';
              }
            } else if (submitBtn) {
              submitBtn.textContent = available && variant && typeof variant.price !== 'undefined'
                ? labels.addToCart + ' — ' + formatMoney(parseInt(variant.price, 10) * qty)
                : (available ? labels.addToCart : labels.unavailable);
            }
          }

          function getMaxQuantity(variant) {
            if (!variant) return 0;

            /* Shopify does not always expose inventory_quantity in product JSON.
               When it is missing, we trust variant.available instead of treating the stock as 0. */
            if (variant.inventory_management && variant.inventory_policy !== 'continue') {
              var rawQty = variant.inventory_quantity;

              if (rawQty === null || typeof rawQty === 'undefined' || rawQty === '') {
                return null;
              }

              var parsedQty = parseInt(rawQty, 10);
              if (!Number.isFinite(parsedQty)) return null;

              return Math.max(parsedQty, 0);
            }

            return null;
          }

          function isSellableVariant(variant) {
            if (!variant || !variant.available) return false;
            var maxQty = getMaxQuantity(variant);
            return maxQty === null || maxQty > 0;
          }

          function getSelectedOptions() {
            return selects.map(function (select) {
              return select.value;
            });
          }

          function setSelectsFromVariant(variant) {
            if (!variant || !variant.options) return;
            selects.forEach(function (select, index) {
              if (typeof variant.options[index] !== 'undefined') {
                var value = String(variant.options[index]);
                // Another coupon may use a value removed by the current color/length filters.
                if (!Array.prototype.some.call(select.options, function (option) { return option.value === value; })) {
                  var option = document.createElement('option');
                  option.value = value;
                  option.textContent = value;
                  select.appendChild(option);
                }
                select.value = value;
              }
            });
          }

          function syncChoiceButtons() {
            if (!choiceButtons.length) return;

            var selected = getSelectedOptions();

            choiceButtons.forEach(function (button) {
              var optionPosition = parseInt(button.dataset.optionPosition || '0', 10);
              var optionIndex = optionPosition - 1;
              var value = button.dataset.optionValue || '';
              var select = selects[optionIndex];
              var isSelected = select && String(select.value) === String(value);
              var isAvailable = true;

              if (Number.isFinite(optionIndex) && optionIndex >= 0) {
                var orderedValues = optionValues[optionIndex] || [];
                var optionOrder = orderedValues.indexOf(value);

                button.style.order = optionOrder > -1 ? String(optionOrder) : '';
                isAvailable = hasAvailableMatch(optionIndex, value, selected);
              }

              button.classList.toggle('is-selected', Boolean(isSelected));
              button.classList.toggle('is-unavailable-hidden', !isAvailable);
              button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
              button.toggleAttribute('hidden', !isAvailable);
              button.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
              button.disabled = !isAvailable;
              button.style.display = isAvailable ? '' : 'none';
            });

            Array.prototype.slice.call(card.querySelectorAll('[data-bb-selected-option-value]')).forEach(function (label) {
              var field = label.closest('[data-bb-option-field]');
              var position = field ? parseInt(field.dataset.optionPosition || '0', 10) : 0;
              var select = selects[position - 1];
              label.textContent = select ? select.value : '';
            });
          }

          function findVariantFromSelected() {
            var selected = getSelectedOptions();

            if (!selected.length && variants.length) {
              return variants.find(isSellableVariant) || variants[0];
            }

            return variants.find(function (variant) {
              if (!variant || !variant.options) return false;

              return selected.every(function (value, index) {
                return String(variant.options[index]) === String(value);
              });
            }) || null;
          }

          function hasAvailableMatch(optionIndex, value, selected) {
            return variants.some(function (variant) {
              if (!isSellableVariant(variant) || !variant.options) return false;
              if (String(variant.options[optionIndex]) !== String(value)) return false;

              return variant.options.every(function (optionValue, index) {
                if (index === optionIndex) return true;
                if (!selected[index]) return true;
                return String(optionValue) === String(selected[index]);
              });
            });
          }

          function valueExistsInSellableVariant(optionIndex, value) {
            return variants.some(function (variant) {
              return isSellableVariant(variant) && variant.options && String(variant.options[optionIndex]) === String(value);
            });
          }

          function rebuildSelectOptions() {
            if (!selects.length) return;

            if (!selectionsReady) {
              var firstSellable = variants.find(isSellableVariant) || variants.find(function (variant) {
                return variant && variant.available;
              }) || variants[0];
              setSelectsFromVariant(firstSellable);
              selectionsReady = true;
            }

            var selected = getSelectedOptions();

            for (var pass = 0; pass < Math.max(selects.length, 1); pass += 1) {
              var changed = false;

              selects.forEach(function (select, index) {
                var values = optionValues[index].filter(function (value) {
                  return hasAvailableMatch(index, value, selected);
                });

                if (!values.length) {
                  values = optionValues[index].filter(function (value) {
                    return valueExistsInSellableVariant(index, value);
                  });
                }

                if (!values.length) {
                  values = optionValues[index].slice();
                }

                var current = selected[index] || select.value;

                var next = values.indexOf(current) > -1 ? current : values[0];

                select.innerHTML = '';

                values.forEach(function (value) {
                  var option = document.createElement('option');
                  option.value = value;
                  option.textContent = value;
                  select.appendChild(option);
                });

                if (next) {
                  select.value = next;
                  if (selected[index] !== next) {
                    selected[index] = next;
                    changed = true;
                  }
                }
              });

              if (!changed) break;
            }

            syncChoiceButtons();
          }

          function findVariant() {
            rebuildSelectOptions();
            return findVariantFromSelected();
          }

          function getQty() {
            var value = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
            if (!Number.isFinite(value) || value < 1) value = 1;
            return value;
          }

          function setQty(value) {
            if (!qtyInput) return;
            qtyInput.value = String(value);
          }

          function updateState() {
            var variant = findVariant();
            var maxQty = getMaxQuantity(variant);
            var qty = getQty();
            var available = isSellableVariant(variant);

            if (maxQty !== null && qty > maxQty) {
              qty = Math.max(maxQty, 1);
              setQty(qty);
            }

            if (variant) {
              variantInput.value = variant.id;
              if (card.querySelector('blankabric-print-coupon')) {
                card.dispatchEvent(new CustomEvent('bb:coupon-change', { detail: { id: variant.id } }));
              }
            }

            if (qtyInput) {
              qtyInput.disabled = !available;

              if (maxQty !== null) {
                qtyInput.setAttribute('max', String(Math.max(maxQty, 1)));
              } else {
                qtyInput.removeAttribute('max');
              }
            }

            if (minusBtn) minusBtn.disabled = !available || qty <= 1;
            if (plusBtn) plusBtn.disabled = !available || (maxQty !== null && qty >= maxQty);

            if (submitBtn) {
              submitBtn.disabled = !available;
            }
            openBtn.disabled = !available || form.hasAttribute('data-bb-cart-pending');

            updateQtySummaryAndTotal(variant, qty, available);

            if (message) {
              if (!variant) {
                message.textContent = labels.combinationUnavailable;
              } else if (!available) {
                message.textContent = labels.optionSoldOut;
              } else if (maxQty !== null && qty >= maxQty) {
                message.textContent = labels.maxQuantity;
              } else {
                message.textContent = '';
              }
            }

            scheduleModalFit();
          }

          function getViewportSize() {
            var visualViewport = window.visualViewport;

            return {
              width: visualViewport && visualViewport.width ? visualViewport.width : window.innerWidth || document.documentElement.clientWidth || 0,
              height: visualViewport && visualViewport.height ? visualViewport.height : window.innerHeight || document.documentElement.clientHeight || 0
            };
          }

          function fitModalToViewport() {
            mediaFitFrame = 0;

            if (!isModalOpen || !modalPanel || !modalMedia) return;

            if (!window.matchMedia('(max-width: 749px)').matches) {
              modalPanel.style.removeProperty('--bb-product-card-modal-media-size');
              return;
            }

            var viewport = getViewportSize();
            if (!viewport.height || !viewport.width) return;

            var maxMediaSize = Math.min(viewport.width * 0.74, 292);
            var minMediaSize = Math.min(maxMediaSize, 86);
            var modalStyles = window.getComputedStyle(modal);
            var modalVerticalPadding = parseFloat(modalStyles.paddingTop) + parseFloat(modalStyles.paddingBottom);
            var availablePanelHeight = viewport.height - modalVerticalPadding;

            modalPanel.style.setProperty('--bb-product-card-modal-media-size', Math.floor(maxMediaSize) + 'px');

            var mediaHeight = modalMedia.offsetHeight || maxMediaSize;
            var nonMediaHeight = modalPanel.scrollHeight - mediaHeight;
            var fittedMediaSize = Math.min(maxMediaSize, Math.max(minMediaSize, availablePanelHeight - nonMediaHeight - 8));

            modalPanel.style.setProperty('--bb-product-card-modal-media-size', Math.floor(fittedMediaSize) + 'px');
          }

          function scheduleModalFit() {
            if (!isModalOpen || mediaFitFrame) return;

            mediaFitFrame = window.requestAnimationFrame(fitModalToViewport);
          }

          function openModal() {
            if (isModalOpen) return;
            form.removeAttribute('data-bb-direct-add');
            isModalOpen = true;

            if (openFrame) {
              window.cancelAnimationFrame(openFrame);
              openFrame = 0;
            }

            if (closeTimer) {
              window.clearTimeout(closeTimer);
              closeTimer = 0;
            }

            hydrateModalMedia();
            modal.hidden = false;
            if (typeof HTMLDialogElement !== 'undefined' && modal instanceof HTMLDialogElement && !modal.open) {
              try {
                if (window.matchMedia('(max-width: 749px)').matches) {
                  modal.showModal();
                } else {
                  modal.show();
                }
              } catch (error) {
                modal.setAttribute('open', '');
              }
            } else {
              modal.setAttribute('open', '');
            }
            card.classList.add('bb-options-active');
            if (!hasScrollLock) {
              lockPageScroll();
              hasScrollLock = true;
            }
            modal.setAttribute('aria-hidden', 'false');
            updateState();
            scheduleModalFit();
            playModalVideos();

            openFrame = window.requestAnimationFrame(function () {
              openFrame = window.requestAnimationFrame(function () {
                openFrame = 0;
                modal.classList.add('is-open');
                scheduleModalFit();
              });
            });

            var firstSelect = modal.querySelector('select, input, button');
            if (firstSelect) {
              window.setTimeout(function () {
                firstSelect.focus({ preventScroll: true });
              }, 180);
            }
          }

          function closeModal() {
            if (!isModalOpen) return;
            isModalOpen = false;

            if (openFrame) {
              window.cancelAnimationFrame(openFrame);
              openFrame = 0;
            }

            if (mediaFitFrame) {
              window.cancelAnimationFrame(mediaFitFrame);
              mediaFitFrame = 0;
            }

            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            pauseModalVideos();
            closeTimer = window.setTimeout(function () {
              closeTimer = 0;

              if (!isModalOpen && !modal.classList.contains('is-open')) {
                if (typeof modal.close === 'function' && modal.open) {
                  modal.close();
                } else {
                  modal.removeAttribute('open');
                }
                modal.hidden = true;
                card.classList.remove('bb-options-active');

                if (hasScrollLock) {
                  unlockPageScroll();
                  hasScrollLock = false;
                }

                if (modalPanel) {
                  modalPanel.style.removeProperty('--bb-product-card-modal-media-size');
                }
              }
            }, closeAnimationMs);
          }

          openBtn.addEventListener('click', function (event) {
            event.preventDefault();
            if (openBtn.disabled) return;
            setQty(1);
            updateState();
            if (!submitBtn || submitBtn.disabled) return;
            form.setAttribute('data-bb-direct-add', '');
            form.requestSubmit(submitBtn);
          });

          // The gift discovery flow still explicitly requests an options dialog.
          openBtn.addEventListener('bb:open-options', openModal);
          card.addEventListener('bb:cart-add-complete', updateState);

          closeBtns.forEach(function (button) {
            button.addEventListener('click', function (event) {
              event.preventDefault();
              closeModal();
            });
          });

          modal.addEventListener('cancel', function (event) {
            event.preventDefault();
            closeModal();
          });

          selects.forEach(function (select) {
            select.addEventListener('change', function () {
              selectionsReady = true;
              updateState();
            });
          });

          card.addEventListener('bb:select-coupon', function (event) {
            var chosen = variants.find(function (variant) { return String(variant.id) === String(event.detail.id); });
            if (!chosen || !isSellableVariant(chosen)) return;
            setSelectsFromVariant(chosen);
            selectionsReady = true;
            updateState();
          });

          choiceButtons.forEach(function (button) {
            button.addEventListener('click', function () {
              if (button.disabled) return;

              var optionPosition = parseInt(button.dataset.optionPosition || '0', 10);
              var select = selects[optionPosition - 1];
              if (!select) return;

              select.value = button.dataset.optionValue || '';
              selectionsReady = true;
              updateState();
            });
          });

          if (minusBtn) {
            minusBtn.addEventListener('click', function () {
              setQty(Math.max(getQty() - 1, 1));
              updateState();
            });
          }

          if (plusBtn) {
            plusBtn.addEventListener('click', function () {
              updateState();
              if (plusBtn.disabled) return;

              var variant = findVariant();
              var maxQty = getMaxQuantity(variant);
              var nextQty = getQty() + 1;

              if (maxQty !== null && nextQty > maxQty) {
                nextQty = maxQty;
              }

              setQty(Math.max(nextQty, 1));
              updateState();
            });
          }

          if (qtyInput) {
            qtyInput.addEventListener('input', updateState);
            qtyInput.addEventListener('change', updateState);
          }

          window.addEventListener('resize', scheduleModalFit);
          if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', scheduleModalFit);
            window.visualViewport.addEventListener('scroll', scheduleModalFit);
          }

          form.addEventListener('submit', function (event) {
            updateState();
            var variant = findVariant();
            var maxQty = getMaxQuantity(variant);
            var qty = getQty();
            var available = isSellableVariant(variant);

            if (!variant || !available || (maxQty !== null && qty > maxQty)) {
              event.preventDefault();
              updateState();
              return;
            }

            /* La soumission est valide : on ferme la carte d'options.
               Le petit délai laisse le thème / l'AJAX panier récupérer le formulaire
               avant de masquer le panneau, puis évite qu'il reste ouvert derrière la popup panier. */
            window.setTimeout(function () {
              closeModal();
            }, 80);
          });

          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && modal.classList.contains('is-open')) {
              closeModal();
            }
          });

          var initialVariant = variants.find(function (variant) {
            return String(variant.id) === card.dataset.bbInitialVariant;
          });
          if (initialVariant && isSellableVariant(initialVariant)) {
            setSelectsFromVariant(initialVariant);
            selectionsReady = true;
          }
          var couponSelect = card.querySelector('[data-print-coupon]');
          if (couponSelect) {
            var referenceCoupon = variants.find(function (variant) { return String(variant.id) === couponSelect.value; });
            if (referenceCoupon) { setSelectsFromVariant(referenceCoupon); selectionsReady = true; }
          }
          updateState();
        });
      }
    };

    window.BBProductCardOptions.init(document);

    document.addEventListener('shopify:section:load', function (event) {
      window.BBProductCardOptions.init(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      window.BBProductCardOptions.init(event.target);
    });

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && (node.matches('[data-bb-product-card]') || node.querySelector('[data-bb-product-card]'))) {
              window.BBProductCardOptions.init(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();
